import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { fetchContractDetails } from './ContractDetailsSlice';
import { ContractDetailsContentSelector } from './ContractDetailsContentSelector';
import { ContractDetails } from '@cp-mx/common';

export function useContractDetails(): AbstractContentState<ContractDetails> {
    return useCmsContent(fetchContractDetails, ContractDetailsContentSelector);
}
